import { formRef } from './consts';
import randomId from 'random-id';

export default function (editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const formCheckboxMId = 'dc-form-cb-m-' + randomId(8, '');
  const formCheckboxFId = 'dc-form-cb-f-' + randomId(8, '');
  const formRadio1Id = 'dc-form-rd-1-' + randomId(8, '');
  const formRadio2Id = 'dc-form-rd-2-' + randomId(8, '');

  if (c.blocks.indexOf(formRef) >= 0) {
    bm.add(formRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="50">
    <path d="M22,5.5 C22,5.2 21.5,5 20.75,5 L3.25,5 C2.5,5 2,5.2 2,5.5 L2,8.5 C2,8.8 2.5,9 3.25,9 L20.75,9 C21.5,9 22,8.8 22,8.5 L22,5.5 Z M21,8 L3,8 L3,6 L21,6 L21,8 Z" fill-rule="nonzero"></path>
    <path d="M22,10.5 C22,10.2 21.5,10 20.75,10 L3.25,10 C2.5,10 2,10.2 2,10.5 L2,13.5 C2,13.8 2.5,14 3.25,14 L20.75,14 C21.5,14 22,13.8 22,13.5 L22,10.5 Z M21,13 L3,13 L3,11 L21,11 L21,13 Z" fill-rule="nonzero"></path>
    <rect x="2" y="15" width="10" height="3"/>
</svg>
        <div>${c.label}</div>`,
      category: c.category,
      content: `
      <form class="dc-form-default dc-form-bordered">
        <div class="col-12 col-md-12">
          <h4 class="title">Form Details</h4>
        </div>
        <div class="form-container row mx-auto" draggable="false" data-gjs-copyable="false" data-gjs-selectable="true" data-gjs-custom-name="Form Container">
            <div class="alert alert-danger alert-message" style="display: none"></div>
            <div class="alert alert-success success-message" style="display: none"></div>
            <div class="form-group col-12 col-md-12">
              <label>Name</label>
              <input name="name" type="text" placeholder="Type here your name" class="form-control input--style" />
            </div>
            <div class="form-group col-12 col-md-12">
              <label>Email</label>
              <input name="email" type="email" placeholder="Type here your email" class="form-control input--style" />
            </div>
              <div class="form-group col-12 col-md-12">
              <input name="sex" type="checkbox" id="${formCheckboxMId}" class="form-check-input dc-checkbox" value="M"/>
              <label class="form-check-label" for="${formCheckboxMId}">M</label>
              </div>
              <div class="form-group col-12 col-md-12">
              <input name="sex" type="checkbox" id="${formCheckboxFId}" class="form-check-input dc-checkbox" value="F"/>
              <label class="form-check-label" for="${formCheckboxFId}">F</label>
              </div>
              <div class="form-group col-12 col-md-12">
              <input name="defaultRadio" type="radio" id="${formRadio1Id}" class="form-check-input dc-radio" value=""/>
              <label class="form-radio-label" for="${formRadio1Id}">Default radio</label>
              </div>
              <div class="form-group col-12 col-md-12">
              <input name="defaultRadio" type="radio" id="${formRadio2Id}" class="form-check-input dc-radio" value=""/>
              <label class="form-radio-label" for="${formRadio2Id}">Default checked radio</label>
              </div>
            <div class="form-group col-12 col-md-12">
              <label>Message</label>
              <textarea name="message" placeholder="Type here your message" class="form-control input--style"></textarea>
            </div>
            <div class="form-group col-12 col-md-12 p-t-10 no-border-bottom">
              <button type="submit" class="btn btn-primary">Send</button>
            </div>
        </div>
      </form>
        `,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
        </div>
  
        <span class="${className}__info">
          <a target="_blank" href="https://academy.drapcode.com/docs/app-builder/forms-component-form" draggable="false">
            <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        c.label
      }?"></i>
          </a>
        </span>
      `,
    });
  }
}
